module.exports = __webpack_public_path__ + "static/investabit-3b8e555edea47ae28761f8d58b562049.png";